import React from "react";
import { asyncComponent } from "@jaredpalmer/after";

export default [
  {
    path: "/",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Home/Home"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/about",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/About/About"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/404",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/404/error404"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/management",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Management/Management"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/documents",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Documents/Documents"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/news",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/News/News"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/deals",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Deals/Deals"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/bonus",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Bonus/Bonus"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/privilege",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Privilege/Privilege"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/production",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Production/Production"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/optica",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Optica/Optica"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/actives",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Actives/Actives"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/purchase",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Purchase/Purchase"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/security",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Security/Security"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/career/:id",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Career/Career"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/rent",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Rent/Rent"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/storenetwork",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Store/Store"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/contacts",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Contacts/Contacts"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/legal",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Legal/Legal"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/rent/:id",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/showRent/ShowRent"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/deals/:id",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Deals/Deals"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/extra/:id",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/Extra/Extra"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "/news/:id",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/NewsAbout/NewsAbout"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
  {
    path: "**",
    exact: true,
    component: asyncComponent({
      loader: () => import("./pages/404/error404"),
      Placeholder: () => <div>...LOADING...</div>,
    }),
  },
];
